namespace AgerLMS.Administration {
    export interface CheckUserForRequest extends Serenity.ServiceRequest {
        username?: string;
        Guid?: string;
        Code?: number;
    }
}
